/** Help for membership / portal / Black Dragon — BT-GSD-KARATE-MEMBERSHIP-PORTAL-001 (EN). */

function topic(key, screenLabel, purpose, actions, warning, nextStep) {
  return { key, screenLabel, purpose, actions, warning, nextStep };
}

export const helpTopicsMembershipEn = {
  "become-member": topic(
    "become-member",
    "Become a member",
    "Register an adult or a minor: identity, health, consents, then demo payment.",
    [
      "Choose Adult or Minor.",
      "Complete identity, emergency contact and parent if minor.",
      "Fill the health form, consents, then pay in demo mode.",
    ],
    "Demo payment only — no real card. Temporary health form until the official document is plugged in.",
    "After activation, sign in to open My space.",
  ),
  "public-calendar": topic(
    "public-calendar",
    "General calendar",
    "See only public organization events.",
    ["Browse, search and sort public events.", "No student or health data is shown."],
    "Internal dojo calendars stay reserved for active members.",
    "Become a member to see your dojo calendar.",
  ),
  "public-black-dragon": topic(
    "public-black-dragon",
    "Public Black Dragon",
    "Public introduction to Black Dragon — a private membership distinct from member status.",
    ["Read public content.", "Become a Shotokan AAMC member before any Black Dragon invitation."],
    "Private Black Dragon content is never visible here.",
    "Complete a Shotokan membership then request or wait for an invitation.",
  ),
  "member-adhesion": topic(
    "member-adhesion",
    "My membership",
    "Review status, renewal, payment and your authorized health information.",
    ["Check active status and period end.", "Review personal and health information."],
    "Health data is protected — it is not listed publicly.",
    "Renew when the period is ending.",
  ),
  "member-calendar": topic(
    "member-calendar",
    "My calendar",
    "See events for your dojo and relevant general events.",
    ["Search and sort events.", "Compare with the public calendar."],
    "Internal events from other dojos are not exposed automatically.",
    "Open Today for the next class.",
  ),
  "member-exams": topic(
    "member-exams",
    "My exams",
    "Review exam history and authorized progress, without private instructor notes.",
    ["See current grade and history.", "Spot a next exam if one is planned."],
    "Private Sensei notes stay hidden in the member space.",
    "Talk to your Sensei about next steps.",
  ),
  "member-black-dragon": topic(
    "member-black-dragon",
    "Black Dragon space",
    "Request, follow an invitation and read content according to visibility.",
    ["Confirm Shotokan membership is active.", "Submit a request if the option is open.", "Read only authorized content."],
    "Without an active Shotokan membership, Black Dragon cannot be activated.",
    "An administrator approves or refuses the request.",
  ),
  "parent-membership": topic(
    "parent-membership",
    "Children membership",
    "Choose a child to see calendar, progress, membership and authorized forms.",
    ["Select the child.", "Review membership and authorized health.", "One parent account can manage several profiles."],
    "The parent does not receive administrative rights automatically.",
    "Complete a renewal from the child's profile.",
  ),
  "admin-membership": topic(
    "admin-membership",
    "Membership cockpit",
    "Track registrations, payments, health, active members, renewals and Black Dragon.",
    [
      "Filter by missing step.",
      "Open the 360 profile.",
      "Invite or approve Black Dragon.",
      "Adjust the annual fee amount.",
    ],
    "Never export health into a general file. Sensei cannot see health by default (temporary policy).",
    "Handle pending payments and incomplete health forms first.",
  ),
  "admin-black-dragon-membership": topic(
    "admin-black-dragon-membership",
    "Black Dragon memberships",
    "Manage Black Dragon requests and invitations with a decision history.",
    ["Approve only if Shotokan membership is active.", "Refuse with actor and date trace."],
    "Black Dragon never replaces member status.",
    "Return to the membership cockpit for the 360 profile.",
  ),
  "admin-official-members": topic(
    "admin-official-members",
    "Official CKA members",
    "Review imported students by instructor, dojo, name, rank and status, then open the 360 profile.",
    [
      "Filter by instructor, dojo, rank, status or adult/minor.",
      "Open Gilles, Marie-Ève, Richard Pik or a student to check relationships.",
      "Re-apply the import: no duplicate must be created.",
    ],
    "Medical information stays out of this list. No login account is created automatically.",
    "Handle rows marked To verify, then open the 360 profile.",
  ),
};
